import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {DetailTrendGraphFC} from "@/pages/rum/v2/details/graphs/fc/DetailTrendGraphFC.tsx";
import {RUMGraphHeader} from "@/pages/rum/v2/details/graphs/RumGraphHeader.tsx";
import {ReportSpec} from "@/pages/rum/v2/details/ReportDefType.ts";

interface PageLoadTrendProps {
  checkName: string;
  headerData: JSON;
  data: JSON;
  reportSpec: ReportSpec;
}

export const PageLoadTrend = ({checkName, headerData, data, reportSpec}: PageLoadTrendProps) => {
  const {user} = useCurrentUserContext();
  return (
    <>
      <RUMGraphHeader title={reportSpec.trend.title} supportLink={reportSpec.doc} />
      <DetailTrendGraphFC
        checkName={checkName}
        data={data}
        noDataMessage={reportSpec.noDataMessage}
        left={reportSpec.trend.left}
        headerData={headerData}
        right={reportSpec.trend.right}
        baselines={reportSpec.trend.baselines}
        bar={reportSpec.trend.bar}
        timezone={user!.account!.timezone}
      />
    </>
  );
};
